/*
 *
 * SystemPopUp
 *
 * @version 1.0.0
 * @author Magarelli-Fabrizio
 * @since 03-Oct-2024
 */

import React from 'react'
import PropTypes from 'prop-types'
import { injectIntl } from 'react-intl'
import MerchantModal from '@nexidigital/merchantmodal'
import Toggle from 'Hoc/ToggleComponent'
import TtlCountdown from 'Components/TtlCountdown'
import formattedMessage, { ariaLabels } from './languageModule'
import './SystemPopUp.scss'

const SystemPopUp = ({ actions, type, intl }) => {
  const popupInfo = {}
  switch (type) {
  case 'extend':
    popupInfo.title = formattedMessage.extendedTitle
    popupInfo.primaryButtonLabel = formattedMessage.extendedButton
    popupInfo.onClose = () => actions.getUserProfile()
    popupInfo.primaryAction = () => actions.getUserProfile()
    break
  case 'expired':
    popupInfo.title = formattedMessage.expiredTitle
    popupInfo.primaryButtonLabel = formattedMessage.expiredButton
    popupInfo.onClose = () => actions.logout()
    popupInfo.primaryAction = () => actions.logout()
    break
  case 'error':
    popupInfo.title = formattedMessage.errorTitle
    popupInfo.description = formattedMessage.errorSubTitle
    popupInfo.ariaModalDescription = intl.formatMessage(ariaLabels.errorSubTitleAriaLabel)
    popupInfo.primaryButtonLabel = formattedMessage.errorButton
    popupInfo.onClose = () => actions.closePopup()
    popupInfo.primaryAction = () => actions.closePopup()
    break
  default:
    break
  }

  return (
    <Toggle>
      <MerchantModal {...popupInfo}>{type === 'extend' && <TtlCountdown />}</MerchantModal>
    </Toggle>
  )
}

SystemPopUp.propTypes = {
  actions: PropTypes.object,
  type: PropTypes.string,
  intl: PropTypes.object,
}

SystemPopUp.defaultProps = {
  actions: {},
  type: '',
  intl: {}
}

export default injectIntl(SystemPopUp)
